/* __next_internal_client_entry_do_not_use__ Button auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { useMaybeDomainStripping } from "@faire/web--source/ui/hooks/useMaybeDomainStripping";
import React from "react";
import styled, { useTheme } from "styled-components";
import { useShouldShowSpinner } from "../../ui/hooks/useShouldShowSpinner";
import { themeOrDefault } from "../Theme";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
import { ButtonStyles } from "./styles";
import { buttonTheme } from "./theme";
import { useGetAttributes } from "./utils";
/**
 * @deprecated use `Button` from `@faire/slate/core/button` - since 2025-02-28
 *
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/button)
 */ export var Button = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var theme = useTheme();
    var _useShouldShowSpinner = useShouldShowSpinner(props.disabled || false, props.loading || false, props.onClick), isDisabled = _useShouldShowSpinner.isDisabled, handleClick = _useShouldShowSpinner.handleClick, shouldShowSpinner = _useShouldShowSpinner.shouldShowSpinner;
    var _useMaybeDomainStripping = useMaybeDomainStripping(props.linkTo, "target" in props ? props.target : undefined), _useMaybeDomainStripping_potentiallyRelativeLink = _useMaybeDomainStripping.potentiallyRelativeLink, potentiallyRelativeLink = _useMaybeDomainStripping_potentiallyRelativeLink === void 0 ? props.linkTo : _useMaybeDomainStripping_potentiallyRelativeLink;
    var childNode = shouldShowSpinner ? /*#__PURE__*/ _jsx(HiddenChildrenWrapper, {
        children: children
    }) : children;
    var _useGetAttributes = useGetAttributes(_object_spread_props(_object_spread({}, props), {
        linkTo: potentiallyRelativeLink
    })), as = _useGetAttributes.as, linkProps = _useGetAttributes.linkProps;
    var buttonRef = props.buttonRef, linkTo = props.linkTo, tertiaryColor = props.tertiaryColor, destructive = props.destructive, loading = props.loading, variant = props.variant, small = props.small, width = props.width, minWidth = props.minWidth, rest = _object_without_properties(props, [
        "buttonRef",
        "linkTo",
        "tertiaryColor",
        "destructive",
        "loading",
        "variant",
        "small",
        "width",
        "minWidth"
    ]);
    return /*#__PURE__*/ _jsxs(StyledButton, _object_spread_props(_object_spread({}, rest, linkProps), {
        ref: buttonRef,
        disabled: isDisabled,
        "aria-disabled": isDisabled,
        as: as,
        onClick: handleClick,
        $tertiaryColor: tertiaryColor,
        $small: small,
        theme: theme,
        $loading: loading,
        $destructive: destructive,
        $variant: variant,
        $width: width,
        $minWidth: minWidth,
        children: [
            childNode,
            shouldShowSpinner && /*#__PURE__*/ _jsx(StyledLoadingSpinner, {
                size: "medium",
                destructive: destructive,
                variant: props.variant
            })
        ]
    }));
};
Button.displayName = "Button";
var HiddenChildrenWrapper = styled.span.withConfig({
    componentId: "sc-8d2fff12-0"
})([
    "visibility:hidden;cursor:inherit;color:inherit;display:inline-flex;align-items:center;justify-content:center;"
]);
var StyledButton = styled.button.withConfig({
    componentId: "sc-8d2fff12-1"
})([
    "",
    " ",
    ""
], ButtonStyles, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var StyledLoadingSpinner = styled(LoadingSpinner).attrs(function(props) {
    var theme = props.theme, _props_variant = props.variant, variant = _props_variant === void 0 ? "primary" : _props_variant;
    var _themeOrDefault_buttons2;
    var buttons2Theme = (_themeOrDefault_buttons2 = themeOrDefault(theme).buttons2) !== null && _themeOrDefault_buttons2 !== void 0 ? _themeOrDefault_buttons2 : buttonTheme;
    var buttons2VariantTheme = buttons2Theme[variant].loading;
    var color = (typeof buttons2VariantTheme === "function" ? buttons2VariantTheme({
        $destructive: props.destructive,
        $variant: variant
    }) : buttons2VariantTheme).color;
    return {
        color: color
    };
}).withConfig({
    componentId: "sc-8d2fff12-2"
})([
    "position:absolute;top:calc(50% - 12px);left:calc(50% - 12px);"
]);
